const online_config = {
  h5_login:'//m.mgtv.com/login/',
  h5_casher: "//club.mgtv.com/act/mgtv_cashier/index.html",
  aphone_casher: "https://app.hitv.com/pay/aphone/index.html",
  iphone_casher: "https://app.hitv.com/pay/iphone/index.html",
  ipad_casher: "https://app.hitv.com/pay/ipad/index.html",
  api_user_info: "//vipact3.api.mgtv.com/api/v1/act/viptype",
  api_vip_info: "//as.mgtv.com/client/user/user_info",
  api_act_stat: "//vipact3.api.mgtv.com/api/v1/act/idx",
  api_vote_list: "//vipact.api.mgtv.com/mapi/act/bet/list",
  api_vote_vote: "//vipact.api.mgtv.com/mapi/act/bet/bet",
  api_vote_award: "//vipact.api.mgtv.com/mapi/act/bet/award",
  api_act_uinfo_add: "//vipact.api.mgtv.com/mapi/act/uinfo/add",
  api_act_uinfo_get: "//vipact.api.mgtv.com/mapi/act/uinfo/get",
  api_logout:"//nuc.api.mgtv.com/Logout",
  create_vip_order: "//as.mgtv.com/client/order/orderBuy",
  wx_share:'https://club.api.mgtv.com/usercenter/v2/mangoLogin/js'
}

const test_config = Object.assign({}, online_config, {
  h5_login:'//m.mgtv.com/login/',
  h5_casher: "http://testclub.bz.mgtv.com/usercenter/buyvip.html"
})


export default {
  online_env: online_config,
  test_env: test_config
}

//
// export default  {
//   online: {
//     h5_login: "//club.mgtv.com/usercenter/login.html",
//     h5_logout: "//club.mgtv.com/usercenter/logout.html",
//     h5_casher: "//club.mgtv.com/usercenter/buyvip.html",
//     aphone_casher: "https://app.hitv.com/pay/aphone/index.html",
//     iphone_casher: "https://app.hitv.com/pay/iphone/index.html",
//     ipad_casher: "https://app.hitv.com/pay/ipad/index.html",
//     api_user_info: "//nuc.api.mgtv.com/GetUserInfo",
//     api_act_stat: "//vipact.api.mgtv.com/mapi/act/idx",
//     api_vote_list: "//vipact.api.mgtv.com/mapi/act/bet/list",
//     api_vote_vote: "//vipact.api.mgtv.com/mapi/act/bet/bet",
//     api_vote_award: "//vipact.api.mgtv.com/mapi/act/bet/award",
//
//   },
//   debug: {
//     h5_login: "http://ottcs.imgo.tv/usercenter/login.html",
//     h5_logout: "http://ottcs.imgo.tv/usercenter/logout.html",
//     h5_casher: "http://ottcs.imgo.tv/usercenter/buyvip.html",
//     aphone_casher: "https://app.hitv.com/pay/aphone/index.html",
//     iphone_casher: "https://app.hitv.com/pay/iphone/index.html",
//     ipad_casher: "https://app.hitv.com/pay/ipad/index.html",
//     api_user_info: "/GetUserInfo",
//     api_act_stat: "//vipact.api.mgtv.com/mapi/act/idx",
//     api_vote_list: "//vipact.api.mgtv.com/mapi/act/bet/list",
//     api_vote_vote: "//vipact.api.mgtv.com/mapi/act/bet/bet",
//     api_vote_award: "//vipact.api.mgtv.com/mapi/act/bet/award",
//   }
// }



// WEBPACK FOOTER //
// ./src/constant/config.js